function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75,2C34.7,2,2,34.7,2,75s32.7,73,73,73s73-32.7,73-73S115.3,2,75,2z M52,111.1c-4.5-0.2-8.9,0-13.6,0c0-16.4,0-32.5,0-48.9 c5.1,0,10.1-0.1,15,0.1c0.5,0,1.3,1.7,1.3,2.6c0.1,7.8,0.1,15.5,0.1,23.3c0,6.7-0.1,13.3,0,20C54.9,110.5,54.2,111.2,52,111.1z  M46.5,56c-5.5,0-9.4-3.4-9.5-8.5c-0.1-5,3.8-8.7,9.2-8.8c5.6,0,9.7,3.6,9.7,8.6C56,52.3,51.9,56,46.5,56z M112.9,108.8 c0,1.9-0.8,2.4-2.5,2.3c-3.8-0.1-7.6-0.2-11.4,0c-2.4,0.1-3.1-0.8-3.1-3.1c0-8.5,0-16.9-0.2-25.4c-0.2-5.7-2.9-8.3-8-8.1 c-4.5,0.1-7.7,3.7-7.7,8.8c0,8.3-0.1,16.5,0,24.8c0,2.2-0.6,3-2.9,2.9c-3.5-0.2-7-0.2-10.5,0c-3,0.2-3.9-0.7-3.9-3.8 c0.2-12.7,0.2-25.3,0.2-38c0-7.2,0-7.2,7.2-7.2c1.6,0,3.2,0,4.8,0c5,0,5,0,5.1,5.5c5.7-6.8,12.6-8,20.2-5.8 c7.4,2.1,12.3,9.2,12.5,18.5C113.1,89.8,112.8,99.3,112.9,108.8z"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.20497553.svg";
export { ForwardRef as ReactComponent };